import { render, staticRenderFns } from "./QuestionMultiple.vue?vue&type=template&id=97df71ca&scoped=true&"
import script from "./QuestionMultiple.vue?vue&type=script&lang=js&"
export * from "./QuestionMultiple.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMultiple.vue?vue&type=style&index=0&id=97df71ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97df71ca",
  null
  
)

export default component.exports